import React, { ComponentProps, FC } from 'react';

import { EvFiltersPanelTrigger } from '@evinced-private/ui-common';

import './ProductFiltersPanel.scss';

type TProductFiltersPanelTriggerProps = ComponentProps<typeof EvFiltersPanelTrigger>;

export const ProductFiltersPanelTrigger: FC<TProductFiltersPanelTriggerProps> = (props) => {
	return (
		<div className="product-filters-panel__trigger">
			<EvFiltersPanelTrigger {...props} />
		</div>
	);
};
